// extracted by mini-css-extract-plugin
export default {"QualityDetailsClaims_chartTitle":"BreakdownChart_QualityDetailsClaims_chartTitle__YIAY8"};